/* jshint esnext: true */
import AbstractModule from './AbstractModule';

import tap from '../ractive/ractive-events-tap';
import fade from '../ractive/ractive-transitions-fade';

import { unescapeHtml } from '../utils/html';

export default class extends AbstractModule {
    constructor (options) {
        super(options);
        this.controller = this.initController();
    }

    /**
     * Creates the Ractive news list controller
     * @return {Ractive object}  Ractive instance
     */
    initController() {
        var _this = this;
        var controller = new Ractive({
            el: this.$el.find('.js-container').get(0),
            template: unescapeHtml(this.$el.find('.js-template:first').html()),
            delimiters: [ '[[', ']]' ],
            data: {
                // Removed 2016-01-10
                // activeYear: window.templateData.activeYear,
                activeCategory: '',
                categoryList: window.templateData.categoryList,
                displayNewsList: true,
                filteredNewsList: [],
                newsList: window.templateData.newsList,
                newsPerPage: 10,
                page: 1,
                state: 'inert'
            },
            computed: {
                hasMoreNews: function () {
                    return this.get('page') < this.maxPages();
                },
                pageArray: function () {
                    var filteredNewsList = this.get('filteredNewsList');
                    var newsPerPage = this.get('newsPerPage');
                    var pageArray = [];
                    var i = 0;
                    var len = this.get('page');
                    for (; i < len; i++) {
                        let min = newsPerPage * i;
                        let max = (newsPerPage * i) + newsPerPage;
                        let page = filteredNewsList.slice(min, max);
                        pageArray[i] = {
                            news: page
                        };
                    }
                    return pageArray;
                }
            },
            partials: {
                image: '<div class="o-background" style="background-image: url({{image}})"></div>'
            },
            events: { tap },
            transitions: { fade },
            /**
             * Used for displaying a filtered (by category) news list on front-end
             * @return {array}
             */
            filteredNewsList: function() {
                var category = this.get('activeCategory');
                var news = this.get('newsList').slice();

                if (category === '' || category === undefined || category === null) {
                    return news;
                } else {
                    return news.filter(function(item) {
                        // In case of multiple categories per news
                        // return arrayContains(item.categories, category);
                        return item.category === category;
                    });
                }
            },
            /**
             * Calculate the max pages possible for featuredNewsList
             * @return {int}
             */
            maxPages: function() {
                var filteredNewsCount = this.get('filteredNewsList').length;
                var newsPerPage = this.get('newsPerPage');
                var remainder = (filteredNewsCount % newsPerPage);
                return (filteredNewsCount - remainder) / newsPerPage + (remainder !== 0 ? 1 : 0);
            },
            /**
             * Allows us to set proxy events and run other tasks when controller is initialized
             * @param  {array}  options  Array of options
             */
            oninit: function(options) {
                this.on({
                    /**
                     * Fired by the year input observer
                     * @param  {object}  event  Ractive event object
                     */
                    // Removed 2016-01-10
                    // loadNewsList: function(event) {
                    //     var parameters = {
                    //         year: this.get('activeYear')
                    //     };

                    //     // Trigger loading transitions
                    //     this.toggleLoading(false).then(() => {
                    //         // Fetch news
                    //         _this.invokeLoadNewsList(parameters, (response) => {
                    //             // Small timeout for animations
                    //             setTimeout(() => {
                    //                 // Test for empty news response. If so, keep old news
                    //                 var news = (response.news.length === 0) ? this.get('newsList').slice() : response.news;

                    //                 // We can now update the newsList data store
                    //                 this.set({
                    //                     newsList: news,
                    //                     page: 1
                    //                 }).then(() => {
                    //                     // Once that is done, we can filter the newsList and redisplay the front-end
                    //                     this.set('filteredNewsList', this.filteredNewsList()).then(() => {
                    //                         this.toggleLoading(true);
                    //                     });
                    //                 });
                    //             }, 600)
                    //         });
                    //     });
                    // },
                    /**
                     * Fired by the load more button
                     */
                    loadNextPage: function() {
                        this.add('page');
                    },
                    /**
                     * Fired by the category input observer
                     * @param  {object}  event  Ractive event object
                     */
                    updateFilteredNewsList: function (event) {
                        this.toggleLoading(false).then(() => {
                            setTimeout(() => {
                                this.set({
                                    filteredNewsList: this.filteredNewsList(),
                                    page: 1
                                }).then(() => {
                                    this.toggleLoading(true)
                                });
                            }, 600);
                        });
                    }
                });

                _this.$document.trigger('refreshSkrollr.Parallax');
                this.fire('updateFilteredNewsList');
            },
            /**
             * Swich values that are toggled between two states on load state
             * @param  {boolean}  state  Controls towards which state the animation goes
             *                           True -> display list
             *                           False -> hide list
             * @return {Promise}         Allows chaining with a .then()
             */
            toggleLoading: function(state) {
                var values = (typeof state === 'boolean' && state === false) ?
                {
                    displayNewsList: false,
                    state: 'loading'
                } : {
                    displayNewsList: true,
                    state: 'inert'
                };
                return this.set(values);
            }
        });

        controller.observe('activeCategory', (newValue, oldValue, keypath) => {
            this.manageObserver('updateFilteredNewsList', controller, newValue, oldValue, keypath);
        });
        // Removed 2016-01-10
        // controller.observe('activeYear', (newValue, oldValue, keypath) => {
        //     this.manageObserver('loadNewsList', controller, newValue, oldValue, keypath);
        // });

        return controller;
    }

    /**
     * Query server for news list by specified year/params and send them to the callback function
     * @param  {array}     data      Object formed by a year
     * @param  {function}  callback  Function to execute after the AJAX request is done
     */
    // Removed 2016-01-10
    // invokeLoadNewsList (data, callback) {
    //     // Default response
    //     var _response = {
    //         news: []
    //     };
    //     var jqxhr = $.ajax({
    //         method: 'GET',
    //         url: 'ajax-news.php',
    //         data: data
    //     })
    //     .done((response) => {
    //         if (response.success === true) {
    //             _response = response;
    //         }
    //     })
    //     .fail(() => {
    //         console.log('error');
    //     })
    //     .always(() => {
    //         callback(_response);
    //     });
    // }

    /**
     * Fire a method on the controller on observer call
     * @param  {string} method     Method name
     * @param  {object} controller Ractive instance
     * @param  {mixed}  newValue
     * @param  {mixed}  oldValue
     * @param  {string} keypath
     * @return {void}
     */
    manageObserver(method, controller, newValue, oldValue, keypath) {
        if (controller.get('state') === 'inert') {
            controller.fire(method);
        } else {
            if (newValue !== oldValue) {
                controller.set(keypath, oldValue);
            }
        }
    }

    destroy() {
        this.controller.teardown();
        this.$el.off('.NewsList');
    }
}
